import { Component } from '@angular/core';
import { FiDataFieldViewBase } from '@fi-app/data-field/data-field-view/data-field-view-base';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { ILightWeightArea, ILightWeightObject, ILocalSearchDataItemModel } from '@fi-shared/models';
import { IObjectDto } from '@fi-shared/models/models';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'data-field-view-roles',
    templateUrl: './roles.component.html',
    standalone: false,
})
export class FiDataFieldViewRolesComponent extends FiDataFieldViewBase {
    FiStateNames = FiStateNames;

    get isNotEmpty() {
        return this.dataFieldObject.Roles && this.dataFieldObject.Roles.length > 0;
    }

    getSearchObjects(role: ILightWeightObject): [ILocalSearchDataItemModel] {
        return [
            {
                Id: role.Id,
                ObjectType: ObjectTypes.Role,
                Name: role.Name,
            },
        ];
    }
}
